// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DevelopmentCommitmentScheduleAndScopeTabQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DevelopmentCommitmentScheduleAndScopeTabQuery = { __typename?: 'Query', developmentCommitment: { __typename?: 'DevelopmentCommitment', id: string, canBeEdited: boolean, contractExhibits?: string | null | undefined, contractSchedule?: string | null | undefined, contractExclusions?: string | null | undefined, contractTerms?: string | null | undefined } };


export const DevelopmentCommitmentScheduleAndScopeTabDocument = gql`
    query DevelopmentCommitmentScheduleAndScopeTab($id: ID!) {
  developmentCommitment(id: $id) {
    id
    canBeEdited
    contractExhibits
    contractSchedule
    contractExclusions
    contractTerms
  }
}
    `;

/**
 * __useDevelopmentCommitmentScheduleAndScopeTabQuery__
 *
 * To run a query within a React component, call `useDevelopmentCommitmentScheduleAndScopeTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentCommitmentScheduleAndScopeTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentCommitmentScheduleAndScopeTabQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDevelopmentCommitmentScheduleAndScopeTabQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DevelopmentCommitmentScheduleAndScopeTabQuery, DevelopmentCommitmentScheduleAndScopeTabQueryVariables> & ({ variables: DevelopmentCommitmentScheduleAndScopeTabQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevelopmentCommitmentScheduleAndScopeTabQuery, DevelopmentCommitmentScheduleAndScopeTabQueryVariables>(DevelopmentCommitmentScheduleAndScopeTabDocument, options);
      }
export function useDevelopmentCommitmentScheduleAndScopeTabLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevelopmentCommitmentScheduleAndScopeTabQuery, DevelopmentCommitmentScheduleAndScopeTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevelopmentCommitmentScheduleAndScopeTabQuery, DevelopmentCommitmentScheduleAndScopeTabQueryVariables>(DevelopmentCommitmentScheduleAndScopeTabDocument, options);
        }
// @ts-ignore
export function useDevelopmentCommitmentScheduleAndScopeTabSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentCommitmentScheduleAndScopeTabQuery, DevelopmentCommitmentScheduleAndScopeTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentCommitmentScheduleAndScopeTabQuery, DevelopmentCommitmentScheduleAndScopeTabQueryVariables>;
export function useDevelopmentCommitmentScheduleAndScopeTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentCommitmentScheduleAndScopeTabQuery, DevelopmentCommitmentScheduleAndScopeTabQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentCommitmentScheduleAndScopeTabQuery | undefined, DevelopmentCommitmentScheduleAndScopeTabQueryVariables>;
export function useDevelopmentCommitmentScheduleAndScopeTabSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentCommitmentScheduleAndScopeTabQuery, DevelopmentCommitmentScheduleAndScopeTabQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DevelopmentCommitmentScheduleAndScopeTabQuery, DevelopmentCommitmentScheduleAndScopeTabQueryVariables>(DevelopmentCommitmentScheduleAndScopeTabDocument, options);
        }
export type DevelopmentCommitmentScheduleAndScopeTabQueryHookResult = ReturnType<typeof useDevelopmentCommitmentScheduleAndScopeTabQuery>;
export type DevelopmentCommitmentScheduleAndScopeTabLazyQueryHookResult = ReturnType<typeof useDevelopmentCommitmentScheduleAndScopeTabLazyQuery>;
export type DevelopmentCommitmentScheduleAndScopeTabSuspenseQueryHookResult = ReturnType<typeof useDevelopmentCommitmentScheduleAndScopeTabSuspenseQuery>;
export type DevelopmentCommitmentScheduleAndScopeTabQueryResult = Apollo.QueryResult<DevelopmentCommitmentScheduleAndScopeTabQuery, DevelopmentCommitmentScheduleAndScopeTabQueryVariables>;